/*
* inputSwitch
*/
export default class inputSwitch {
  constructor() {
    this.$inputs = document.querySelectorAll('[data-target="inputSwitch"]');
  }

  attachEvent() {
    Array.prototype.forEach.call( this.$inputs, $input => {
      const inputName = $input.getAttribute('data-name');
      const contents = document.querySelector('[data-target="contents"]');

      window.addEventListener('pageshow', () => {
        const inputArray = Object.values(this.$inputs);
        const checked = inputArray.find(input => input.checked) ? inputArray.find(input => input.checked).value : null;
        const select = contents.classList.contains(checked);

        if(select) {
          contents.classList.add('is-active');
        } else {
          contents.classList.remove('is-active');
        }
      });

      $input.addEventListener('change', () => {
        const select = contents.classList.contains(inputName);

        if(select) {
          contents.classList.add('is-active');
        } else {
          contents.classList.remove('is-active');
        }
      });
    });
  }
}
